import Axios from 'axios';

async function BlogData() {
    let response = await Axios.post(`${process.env.REACT_APP_AUX_ENDPOINT}/blogdata`);
    return await response;
}

export default BlogData;